import React from 'react'
import { NavItem } from './types'
import once from 'lodash.once'

type TableOfContentsData<T> = {
  isSelectedItem: (item: T) => boolean
  inActiveItemPath: (item: T) => boolean
  onItemSelect: (item: T) => void
  itemWrapper: (component: React.ReactElement, item: T) => React.ReactElement
}

export const createTocContext = once(<T extends NavItem>() =>
  React.createContext<TableOfContentsData<T>>({
    isSelectedItem: () => false,
    inActiveItemPath: () => false,
    onItemSelect: () => {},
    itemWrapper: (c) => c,
  }),
)

export const useTocContext = <T extends NavItem>() =>
  React.useContext(createTocContext<T>())
